import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Expansion is presentation-only. Keep descendants mounted so local drafts survive closing.
export const ConfigDisclosure = ({ id, title, summary, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return <section className="agent-config-disclosure" data-testid={`${id}-section`}>
    <button type="button" className="agent-config-disclosure-trigger" onClick={() => setOpen(value => !value)}
      aria-expanded={open} aria-controls={`${id}-content`} data-testid={`${id}-toggle`}>
      <span><strong>{title}</strong>{summary && <small data-testid={`${id}-summary`}>{summary}</small>}</span>
      <ChevronDown size={16} className={open ? 'is-open' : ''} aria-hidden="true" />
    </button>
    <div id={`${id}-content`} hidden={!open} className="agent-config-disclosure-content" data-testid={`${id}-content`}>
      {children}
    </div>
  </section>;
};